module.exports = __webpack_public_path__ + "userprofiles3.1.svg?70926c0c0c5cd79afa922c555a7f3a0f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/userprofiles3.1.svg
// module id = 37
// module chunks = 0